import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import AiFirmSetting from './AiFirmSetting';
import FileIntelligenceSetting from './FileIntelligenceSetting';
import TaxDeliverySettings from './TaxDeliverySettings';

export default function Settings() {
  const { enableAi } = useFlags();

  return (
    <>
      {enableAi && <AiFirmSetting />}
      <FileIntelligenceSetting />
      <TaxDeliverySettings />
    </>
  );
}
